import apiFetch from '../apiFetch'

export default function () {
  return apiFetch({endPoint: `Analisis/obtenerCodigoAnalisis`, method: 'GET', body: null})
}
